<template>
  <!-- <div id="content"> -->
     <!--  <div>
      <div class="d-flex">
        <div sm="4" class="col-xs-4"></div>
        <div sm="4" class="col-xs-4">
         {{ $t('lang.horariotienda.apertura') }}
        </div>
        <div sm="4" class="col-xs-4">
          {{ $t('lang.horariotienda.cierre') }}
        </div>
      </div> 
      <div class="mt-15">
        <div sm="4" class="col-xs-4">{{ $t('lang.horariotienda.manana') }}</div>
        <div sm="4" class="col-xs-4">
          <b-form-input type="time" v-model="horariotienda.msht_aperturaman"></b-form-input>
        </div>
        <div sm="4" class="col-xs-4">
           <b-form-input type="time" v-model="horariotienda.msht_cierreman"></b-form-input>
        </div>
      </div> 
      <div class="mt-15">
        <div sm="4" class="col-xs-4">{{ $t('lang.horariotienda.tarde') }}</div>
        <div sm="4" class="col-xs-4">
          <b-form-input type="time" v-model="horariotienda.msht_aperturatar" ></b-form-input>
        </div>
        <div sm="4" class="col-xs-4">
           <b-form-input type="time" v-model="horariotienda.msht_cierretar" ></b-form-input>
        </div>
      </div>
      <div class="mt-5">
        <div sm="4" class="col-xs-4">{{ $t('lang.horariotienda.rango') }}</div>
        <div sm="2" class="col-xs-2">
          <b-form-input type="number" v-model="horariotienda.msht_rangohora"></b-form-input>
        </div>
      </div>
      <div class="mt-5">
        <div sm="4" class="col-xs-4">{{ $t('lang.horariotienda.numcita') }}</div>
        <div sm="2" class="col-xs-2">
          <b-form-input type="number" v-model="horariotienda.msht_numcitas"></b-form-input>
        </div>
      </div>
     alerta -->
      <!--<div class="ml-2 mr-2 mt-5" >
        <div sm="2" class="col-xs-2"/>
        <div sm="8" class="col-xs-8">
           CORRECTO 
          <v-alert
            size="sm"
            :show="dismissCountDownCorrect"
            variant="primary"
            @dismissed="dismissCountDownCorrect=0"
            @dismiss-count-down="countDownChangedCorrect">
            {{ $t('lang.personas.alerta.correcto') }}
          </v-alert>-->
          <!-- ERROR
          <v-alert
            size="sm"
            :show="dismissCountDownError"
            variant="danger"
            @dismissed="dismissCountDownError=0"
            @dismiss-count-down="countDownChangedError">
            {{ errorLit }}
          </v-alert>
        </div>
        <div sm="2" class="col-xs-2"/>
      </div> -->
      <!-- FIN alerta --> 
      <!--<div class="mt-15">
        <div sm="6" class="col-xs-6">
                <v-btn class="mt-3" block @click="$emit('cerrar')">{{ $t('lang.comun.cancelar') }}</v-btn>
        </div>

      </div>   
        <v-btn dark fab absolute large bottom right class="orange guardar" @click="createHorarioTienda();">
            {{ $t('lang.comun.guardar') }}
            <v-icon>save</v-icon>
          </v-btn>
    </div>-->
        <!-- Footer de botones -->
    <!-- <div id='footer'>

      <img class='btn-footer-izq' src='@/assets/images/Btn-ESC.gif'>
      <label class='txt-footer-izq'>{{ $t('lang.comun.salir') }}</label>
      
      <img class='btn-footer-der pointer' src='@/assets/images/Btn-FIN.gif' @click="createHorarioTienda()">
      <label class='txt-footer-der'>{{ $t('lang.comun.grabardatos') }}</label>
    </div> -->
    <!-- FIN. Footer de botones -->
  <!-- </div> -->

   <div class="px-5 py-4 horario-tienda">
      <div class="d-none">
        <p>
         {{ $t('lang.horariotienda.apertura') }}
        </p>
        <p>
          {{ $t('lang.horariotienda.cierre') }}
        </p>
      </div> 
      <div class="d-flex d-flex align-baseline mr-5">
        <h3 class="mb-0  primary-color text-uppercase">{{ $t('lang.horariotienda.manana') }}</h3>
          <v-menu
            ref="menu1"
            v-model="horariotiendamsht_aperturaman"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="horariotienda.msht_aperturaman"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="horariotienda.msht_aperturaman"
                :label="$t('lang.horariotienda.apertura')"
                append-icon="schedule"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="horariotiendamsht_aperturaman"
              v-model="horariotienda.msht_aperturaman"
              full-width
              @click:minute="$refs.menu1.save(horariotienda.msht_aperturaman)"
            ></v-time-picker>
          </v-menu>

          <v-menu
            ref="menu2"
            v-model="horariotiendamsht_cierreman"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="horariotienda.msht_cierreman"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="horariotienda.msht_cierreman"
              :label="$t('lang.horariotienda.cierre')"
              append-icon="schedule"
              readonly
              v-bind="attrs"
              v-on="on"
                class="ml-5"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="horariotiendamsht_cierreman"
            v-model="horariotienda.msht_cierreman"
            full-width
            @click:minute="$refs.menu2.save(horariotienda.msht_cierreman)"
          ></v-time-picker>
        </v-menu>
      </div> 
      <div class="d-flex align-baseline mr-5">
        <h3  class="mb-0 h4 text-weight primary-color text-uppercase ">{{ $t('lang.horariotienda.tarde') }}</h3>
          <v-menu
            ref="menu3"
            v-model="horariotiendamsht_aperturatar"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="horariotienda.msht_aperturatar"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="horariotienda.msht_aperturatar"
                :label="$t('lang.horariotienda.apertura')"
                append-icon="schedule"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="horariotiendamsht_aperturatar"
              v-model="horariotienda.msht_aperturatar"
              full-width
              @click:minute="$refs.menu3.save(horariotienda.msht_aperturatar)"
            ></v-time-picker>
          </v-menu>
          <v-menu
            ref="menu4"
            v-model="horariotiendamsht_cierretar"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="horariotienda.msht_cierretar"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
            >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                class="ml-5"
                v-model="horariotienda.msht_cierretar"
                :label="$t('lang.horariotienda.cierre')"
                append-icon="schedule"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="horariotiendamsht_cierretar"
              v-model="horariotienda.msht_cierretar"
              full-width
              @click:minute="$refs.menu4.save(horariotienda.msht_cierretar)"
            ></v-time-picker>
          </v-menu>     
      </div>
      <div class="d-flex align-center mr-5">
         <h3 class="mb-0 primary-color text-uppercase">{{ $t('lang.horariotienda.rango') }}</h3>
         <div class="mt-0">
         <v-slider
            v-model="horariotienda.msht_rangohora"
            class="align-center"
            :max="horariotiendamsht_rangohora"
            :min="minb"
            hide-details
             thumb-label="always"
          >
            <!-- <template v-slot:append>
              <v-text-field
                v-model="horariotienda.msht_rangohora"
                class="mt-0 pt-0 mb-2"
                hide-details
                single-line
                type="number"
                style="width: 60px"
              ></v-text-field>
            </template> -->
          </v-slider>
          </div>
      </div>
       <div class="d-flex align-center mr-5">
         <h3 class="mb-0 primary-color text-uppercase">{{ $t('lang.horariotienda.numcita') }}</h3>
         <div>
          <v-slider
              v-model="horariotienda.msht_numcitas"
              class="align-center"
              :max="horariotiendamsht_numcitas"
              :min="minb"
              hide-details
               thumb-label="always"
            >
              <!-- <template v-slot:append>
                <v-text-field
                  v-model="horariotienda.msht_numcitas"
                  class="mt-0 pt-0"
                  hide-details
                  single-line
                  type="number"
                  style="width: 60px"
                ></v-text-field>
              </template> -->
            </v-slider>
          </div>
      </div>
      <div class="mt-15">
        <!--<div sm="6" class="col-xs-6">
                <v-btn class="mt-3" block @click="$emit('cerrar')">{{ $t('lang.comun.cancelar') }}</v-btn>
        </div>-->
      </div>   
        <v-btn dark fab absolute large bottom right class="orange guardar" @click="createHorarioTienda();">
            <!-- {{ $t('lang.comun.guardar') }}-->
            <v-icon>save</v-icon>
          </v-btn>
    </div>
</template>
<script>
import { HorariotiendaApiService } from '@/api/HorariotiendaApiService'
import { Util } from '@/api/Util'

const horariotiendaApiService = new HorariotiendaApiService()
const util = new Util()
const moment = require("moment")

export default {
  data () {
    return {
      aperturatar: null,
      mina: 0,
      maxa: 30,
      horariotiendamsht_rangohora: 20,
      minb: 0,
      maxb: 10,
      horariotiendamsht_numcitas:4,
      menuhour:false,
      horariotiendamsht_aperturatar:false,
      horariotiendamsht_cierretar:false,
      horariotiendamsht_cierreman:false,
      horariotiendamsht_aperturaman:false,
      opuid: this.$store.getters.getOpuid,
      // Tiempo en segundos que se muestra el mensaje de alerta
      horariotienda: {
        msht_id: 0,
        msht_numcitas: 0,
        msht_rangohora: 0,
        msht_aperturaman: '',
        msht_cierreman: '', 
        msht_aperturatar: '',
        msht_cierretar: '',
        msht_opuid:this.opuid
      },
      errorLit:''
    }
  },
  created () {
    this.init()
  },
  watch: {
    cambiotienda (value) {
      this.opuid = value;
      this.init()
    }
  },
  methods: {
    init () {
      this.getHorarioTiendaByOpuid()
    },
    createHorarioTienda () {
        //this.diatrabajo.msdiatrabajocalenlabid = this.calenlabselect
         if (this.horariotienda.msht_aperturaman == null || this.horariotienda.msht_aperturaman == '' ||
            this.horariotienda.msht_cierreman == null || this.horariotienda.msht_cierreman == '' ||
            this.horariotienda.msht_aperturatar == null || this.horariotienda.msht_aperturatar == '' ||
            this.horariotienda.msht_cierretar == null || this.horariotienda.msht_cierretar == '' ||
            this.horariotienda.msht_numcitas == null || this.horariotienda.msht_numcitas == '' ||
            this.horariotienda.msht_rangohora == null || this.horariotienda.msht_rangohora == '') {
            
            this.showErrorAlert(this.$t('lang.horariotienda.error.completar'))
        } else {
          let horariotiendaAux = Object.assign({}, this.horariotienda)
          horariotiendaAux.msht_aperturaman=moment(horariotiendaAux.msht_aperturaman, "H:mm")
          horariotiendaAux.msht_cierreman=moment(horariotiendaAux.msht_cierreman, "H:mm")
          horariotiendaAux.msht_aperturatar=moment(horariotiendaAux.msht_aperturatar, "H:mm")
          horariotiendaAux.msht_cierretar=moment(horariotiendaAux.msht_cierretar, "H:mm")
          horariotiendaApiService.createHorarioTienda(horariotiendaAux)
              .then(data => {
                this.showCorrectAlert(this.$t('lang.horariotienda.ok'))
                util.mostrarEnConsola('HorarioTienda - createHorarioTienda', data.status, 'OK')
                // this.getHorarioTiendaByOpuid()
                this.$emit('cambiarHorario', this.horariotienda, false)
              })
              .catch(error => {
                this.showErrorAlert(this.$t('lang.horariotienda.error.otro'))
                util.mostrarEnConsola('HorarioTienda - createHorarioTienda', error, 'ERROR')
              })
        }
    },
    getHorarioTiendaByOpuid () {
      if (this.opuid) {
        horariotiendaApiService.getHorarioTiendaByOpuid(this.opuid)
          .then(data => {
            // console.log(data)
            if (data) {
               this.horariotienda = data [0]
            }
            else {
              this.horariotienda.msht_id = 0
              this.horariotienda.msht_numcitas = 0
              this.horariotienda.msht_rangohora =  0
              this.horariotienda.msht_aperturaman = ''
              this.horariotienda.msht_cierreman = ''
              this.horariotienda.msht_aperturatar = ''
              this.horariotienda.msht_cierretar = ''
              this.horariotienda.msht_opuid= this.opuid
            }
            this.$emit('cambiarHorario', this.horariotienda, false)
            util.mostrarEnConsola('HorarioTienda - getHorarioTiendaByOpuid', data.length, 'OK')
            
          })
          .catch(error => {
            this.horariotienda.msht_id = 0
            this.horariotienda.msht_numcitas = 0
            this.horariotienda.msht_rangohora =  0
            this.horariotienda.msht_aperturaman = ''
            this.horariotienda.msht_cierreman = ''
            this.horariotienda.msht_aperturatar = ''
            this.horariotienda.msht_cierretar = ''
            this.horariotienda.msht_opuid= this.opuid
            util.mostrarEnConsola('HorarioTienda - getHorarioTiendaByOpuid', error, 'ERROR')
          })
      }
    },
    showCorrectAlert (mensaje) {
      this.$root.$emit('mostrarAlerta', mensaje, 'info')
    },
  
    showErrorAlert (mensaje) {
      this.$root.$emit('mostrarAlerta', mensaje, 'error')
    },
  },
  computed: {
    cambiotienda () {
      return this.$store.getters.getOpuid;
    }
  }
}
</script>
